
import { RevButton } from '@ds/components/Button'
import { RevIllustration } from '@ds/components/Illustration'

import translations from './NoOffer.translations'

export default {
  components: {
    RevButton,
    RevIllustration,
  },
  computed: {
    translations: () => translations,
  },
  mounted() {
    this.$emit('tracking', { type: 'noOffer' })
  },
  methods: {
    handleSellOtherClick() {
      this.$emit('sell-other')
    },
  },
}
